export default __webpack_public_path__ + "static/media/client.4c2e192b.png";